import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";
import { getUserDetails } from "../utils/userDetailsUtils";

const getTSRDetails = async (tsrid) => {
  const user = getUserDetails();
  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getTSRDetails&companyId=${user.companyid}&tsrid=${tsrid}`,
  );
  return response.data;
};

export const useGetTSRDetailsQuery = (tsrid, options = {}) => {
  return useQuery({
    queryKey: ["getTSRDetails", tsrid],
    queryFn: () => getTSRDetails(tsrid),
    enabled: !!tsrid,
    staleTime: Infinity,
    ...options,
  });
};

export default useGetTSRDetailsQuery;
